export default __webpack_public_path__ + "static/media/bet365.42882109.mp4";